/**
 * Pure warm-geolocation decision matrix for Obchody directory (G4).
 *
 * First-time visitors (no session flag) must never be surprise-prompted on nameAsc.
 * After a successful fix this tab, `prompt` + flag still attempts silent warm
 * (Safari-class quirks where Permissions API stays `prompt` after grant).
 */

export type DirectoryGeoPermissionProbe =
  | 'granted'
  | 'prompt'
  | 'denied'
  | 'unavailable'
  | 'queryFailed';

export type DirectoryGeoWarmAction = 'warm' | 'skip' | 'clearFlagAndSkip';

/**
 * @param permission - Permissions API state, or unavailable/queryFailed when absent/throws
 * @param sessionAllowed - `rpapp.customer.geoAllowed.v1` from a prior successful fix this tab
 */
export function decideDirectoryGeoWarm(
  permission: DirectoryGeoPermissionProbe,
  sessionAllowed: boolean,
): DirectoryGeoWarmAction {
  if (permission === 'granted') {
    return 'warm';
  }
  if (permission === 'denied') {
    return 'clearFlagAndSkip';
  }
  if (permission === 'prompt') {
    // Prior success this tab → best-effort silent acquire; no flag → never prompt.
    return sessionAllowed ? 'warm' : 'skip';
  }
  // unavailable | queryFailed
  return sessionAllowed ? 'warm' : 'skip';
}
